import { FC } from 'react';

import { Check, Wallet } from 'lucide-react';

import { formatOrderAmount } from './orderRevisionUtils';
import { AnalyticsCardsRow } from '../../../components/shared/AnalyticsCardsRow';

interface Props {
    completedCount: number;
    completedTotalAmount: number;
}

export const SalesAnalyticsRow: FC<Props> = ({
    completedCount,
    completedTotalAmount,
}) => {
    return (
        <AnalyticsCardsRow
            items={[
                {
                    label: 'Завершені замовлення',
                    value: completedCount,
                    icon: Check,
                    iconWrapperClassName: 'bg-green-500/10',
                    iconClassName: 'text-green-500',
                    testId: 'sales-completed-orders',
                },
                {
                    label: 'Сума завершених замовлень',
                    value: formatOrderAmount(completedTotalAmount),
                    icon: Wallet,
                    iconWrapperClassName: 'bg-primary/10',
                    iconClassName: 'text-primary',
                    testId: 'sales-completed-total',
                },
            ]}
        />
    );
};
